export default __webpack_public_path__ + "static/media/82.f480cd1e.jpeg";